import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import styles from './right-panel-loading-skeleton.module.scss';

export function RightPanelLoadingSkeleton(): ReactElement {
  return (
    <div className={styles.container} aria-hidden>
      <div className={styles.row}>
        <SkeletonBrick height={14} width={110} />
        <SkeletonBrick height={24} width={32} />
      </div>
      <div className={styles.row}>
        <SkeletonBrick height={14} width={40} />
        <SkeletonBrick height={24} width={140} />
      </div>
      <div className={styles.row}>
        <SkeletonBrick height={14} width={150} />
        <SkeletonBrick height={24} width={32} />
      </div>
    </div>
  );
}
